import React, { Component } from 'react';
import { keyMap } from '@locales/lokalise/keyMap';
import { CONSTANTS } from 'components/shared/constants';
import DetailsTable from 'components/shared/detailsTable';
import { ENUM_CONSTANTS } from 'components/shared/enum.constants';
import { EmptyObject } from 'components/shared/shared.interfaces';
import { getTableLabel, getValueFromEnums } from 'utils/helper';
import { QFormInfo } from './qforms.types';

interface IProps {
  data: QFormInfo | EmptyObject;
}

const COLUMNS = [
  {
    key: 'declineReason',
    name: keyMap.sharedFieldsDeclineReason,
    render: (data: QFormInfo, value: string) => getValueFromEnums(value, ENUM_CONSTANTS.DECLINE_REASON),
  },
  {
    key: 'publicComment',
    name: keyMap.sharedFieldsComment,
  },
];

class StatusInfo extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  getColumns(data: QFormInfo) {
    const columns = [...COLUMNS];
    const idx = columns.findIndex((col) => col.key === 'declineReason');

    if (data.status !== CONSTANTS.Q_FORM_STATUS.DECLINED) {
      columns.splice(idx, 1);
    }

    return columns;
  }

  render() {
    const { data } = this.props;

    return (
      <div className="status-info">
        <div className="status-info__status">{getTableLabel(data.status, ENUM_CONSTANTS.Q_FORM_STATUS)}</div>
        <DetailsTable
          // @ts-ignore: remove after translating into typescript
          columns={this.getColumns(data)}
          data={data}
        />
      </div>
    );
  }
}

export default StatusInfo;
